import React from 'react';
import { useFormikContext } from 'formik'
import { H1, P } from 'components/text';
import { TextField, FieldGroup, RadioButton, DropdownField } from 'components/forms';
import { useApplication } from 'lib/application-provider';
import { HelpSection } from 'pages/Start';

const BusinessInfo = () => {
  const { values } = useFormikContext();
  const application = useApplication();
  
  let countries = [];
  if (application.metadata) {
    countries = application.metadata.entity.children.address.children.country.choices;
    countries = countries.map(c => ({ value: c.value, label: c.display_name}))
  }
  
  return (
    <>
      <H1>Business Information</H1>
      <HelpSection>
        <P>
          Note: you will need to provide the following supporting documentation:
        </P>
        <ul>
          <li>
            Certificate of Good Standing
          </li>
          <li>
            Organization Documents 
          </li>
          <li>
            Anti-Money Laundering (AML) policy
          </li>
          <li>
            Beneficial Owners' Identity Documents
          </li>
          <li>
            Legal Entity Identifier (LEI)
          </li>
        </ul>
      </HelpSection>

      <TextField
        name="entity.name"
        label="Name of entity"
        required
      />
      
      <TextField
        name="entity.company_url"
        label="Company website (optional)"
        type="url"
        placeholder="https://example.com"
      />
      
      <FieldGroup name="entity.kind" label="Kind">
        <RadioButton name="entity.kind" value="corporation">
          Corporation
        </RadioButton>
        <RadioButton name="entity.kind" value="llc">
          LLC
        </RadioButton>
        <RadioButton name="entity.kind" value="partnership">
          Partnership
        </RadioButton>
        <RadioButton name="entity.kind" value="other">
          Other
        </RadioButton>
        { values && values.entity && values.entity.kind && values.entity.kind.includes('other') &&
          <TextField
            name="entity.kind_if_other"
            placeholder="Please specify"
          />
        }
      </FieldGroup>
      
      <hr />
      
      <TextField
        name="entity.address.address"
        label="Business address"
        required
      />
      
      <TextField
        name="entity.address.address_2"
        label="Business address line 2 (optional)"
      />
      
      <TextField
        name="entity.address.city"
        label="City"
        required
      />
      
      <TextField
        name="entity.address.state"
        label="State/Province/Region"
        required
      />
      
      <TextField
        name="entity.address.zip_postal_code"
        label="Zip/Postal code"
        required
      />
      
      <DropdownField 
        name="entity.address.country"
        label="Country"
        required
        options={countries}
        menuPlacement="top"
      />
    </>
  );
};

export default BusinessInfo;
